












import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'NavigationDrawerMyProfileButton',

  computed: {
    ...mapGetters('user', [
      'getUser',
      'isLoggedIn',
    ]),
  },

  methods: {
    goToProfile() {
      if (this.isLoggedIn) {
        this.$router.push(`/profile/${this.getUser.id}`);
      }
    },
  },
});
